// import { has } from 'lodash'
import { formatCurrency } from './utils'

export const levels = {
    1: 0.5,
    2: 0.7908,
    3: 0.83067,
    4: 0.9,
}

export const getLevelPrices = (price) => {
    const levelPrices = {}
    Object.keys(levels).forEach((key) => {
        levelPrices[key] = (Number(price) * levels[key]).toFixed(0)
    })
    return levelPrices
}

// export const processROSData = (data) => {
//     const { Records } = data
//     let records = Records.filter((record) => has(record, 'EstimatedValue')) // remove all which does not have EstimatedValue
//     records = records.map((record) => {
//         const options = Object.keys(levels).map((level) => {
//             const key = `Option ${level}`
//             return {
//                 [key]:
//                     Number(levels[level]) *
//                     Number(record.EstimatedValue.EstimatedValue),
//             }
//         })

//         const { Address, City, State, Zip } = record.PropertyAddress

//         return {
//             Address: `${Address} ${City}, ${State} ${Zip}`,
//             RecordID: record.RecordID,
//             EstimatedValue: record.EstimatedValue.EstimatedValue,
//             EstimateObject: record.EstimatedValue,
//             ...options,
//         }
//     })
//     // Now want only 10 offers
//     return records.slice(0, 10)
// }

export const formatOfferPrice = (offer) => {
    return Number(offer) > 0 ? formatCurrency(offer) : 'Call for Offer'
}
